<p-toast position="bottom-left">
</p-toast>
<div [class.twofactor-wrapper]="isLoginFlow" class="twofa-login">

  @if(isLoginFlow) {
    <div class="column__figure">

      <h2>Multi-Factor <br>
        Authentication</h2>
      <div class="figure__icon"><img src="assets/images/multifactor.svg" alt="Manage Your Account"></div>
      <p>Manage Your Account</p>
    </div>
  }

  <div class="column__content">
    @if(isLoginFlow) {
      <img src="assets/images/logo.svg" class="logo" alt="Flecx">
    }

    <h1>Email verification</h1>
      <div class="form-field">
        <div class="pills-wrapper">
          <div class="pills pills--cover-profile">
            <div class="pills__content hand">
              @if(email) {
                <i class="fa fa-envelope"></i>
                <span class="tf-label pl-6">{{email}}</span>
              }

              @if(!isLoginFlow && emailCount <= 0) {
                <button class="btn-send" (click)="sendCodeEmail()">Send Code</button>
              }
            </div>
          </div>
        </div>
      </div>

      @if(isEmailSent) {
        <p class="small-text mt-15">
          An email has been sent to you, please copy the code and paste below.
        </p>
      }

      <div class="form-field">
        @if(!isEmailSent) {
          <div class="tf-label">
            <label class="form__label">Verification Code</label>
          </div>
        }

        <input class="form__input" type="text" name="code" [(ngModel)]="code" [disabled]="!isEmailSent" [placeholder]="!isLoginFlow ? 'Enter Verification Code' : ''" required>
        @if(isError && !code) {
          <div class="alert error-msg">
              Code is required.
          </div>
        }
      </div>

      @if(isEmailSent && emailCount > 0 && emailCount <=3) {
        <div class="form__group">
          @if (timeLeft > 0) {
            <p class="small-text">You can resend the code in {{ displayTimeLeft }}.</p>
          } @else {
            <a class="dont-get-email hand" (click)="sendCodeEmail()">Didn't get the email? Send again.</a>
          }
        </div>
      }

      <div class="mt-15">
        <button (click)="verifyCode(code)" [disabled]="emailCount <= 0">Verify</button>
      </div>
      <div class="mt-15">
      @if(verified == null){
        Can’t access or forgot your email? <br> You can <a routerLink="/recovery-code-verification"> log in with a recovery code</a>.
      }  
    </div>
      @if(isLoginFlow) {
        <div class="mt-10">
          <button class="secondary" (click)="onBack()">Back to Login</button>
        </div>
      }
  </div>
</div>
